import { Step } from "./Step";
import { MultiLanguage } from "../../MultiLanguage";
import { FilePropertiesValidation } from "../../FilePropertiesValidation";

export class RequirementStep extends Step {
    private _id: string;
    private _description: MultiLanguage;
    private _documentDescription: MultiLanguage;
    private _fileProperties: any;

    constructor(step: any) {
        super(step);
        this._id = step.requirementId;
        this._name = new MultiLanguage(step.title);
        this._description = new MultiLanguage(step.description);
        this._documentDescription = new MultiLanguage(step.documentDescription);
        this._fileProperties = new FilePropertiesValidation();
    }

    public get id(): string {
        return this._id;
    }
    public get description(): MultiLanguage {
        return this._description;
    }
    public get documentDescription(): MultiLanguage {
        return this._documentDescription;
    }
    public get fileProperties(): any{
        return this._fileProperties;
    }
    public set fileProperties(fileProperties: any){
        this._fileProperties = fileProperties;
    }
}